let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("agyBn")).then(() => parcelRequire('jMzOa'));